export default {
  videoURL: 'https://vimeo.com/431487046/4665431b80',
  wallpaper: '/assets/img/tour/wallpaper-de.jpg',
  onPlay: (controller) => {
    controller.guide.show();
  },
  onEnd: (controller) => {
    controller.guide.hide();
    controller.screen.showPage('vg-end.html');
  },
  sequences: [
    {
      id: 'welcome',
      title: 'Willkommen zur virtuellen interaktiven Führung',
      start: 0,
      end: 2096 / 30,
      onEnter: (controller) => {
        controller.screen.clear();
      },
      onExit: () => {
      },
      sequences: [],
    },
    {
      id: 'piano-genie',
      title: '1 - Piano Genie',
      start: 2129 / 30,
      end: 9221 / 30,
      onEnter: (controller) => {
        controller.screen.showPage('/apps/piano-genie-vg/index.html');
      },
      onExit: () => {},
      sequences: [
        {
          id: 'piano-genie-play',
          start: 2833 / 30,
          end: 2857 / 30,
          onEnter: (controller) => {
            controller.guide.showPrompt('Hier klicken, um weiterzumachen.');
          },
          onExit: (controller) => {
            controller.guide.hidePrompt();
          },
        },
      ],
    },
    {
      id: 'neural-numbers',
      title: '2 - Neural Numbers',
      start: 9242 / 30,
      end: 16815 / 30,
      onEnter: (controller) => {
        controller.guide.showLoader();
        controller.screen.showPage('vg-neural-numbers.html').then(() => {
          controller.guide.hideLoader();
        });
        controller.screen.preloadImage('/assets/img/tour/neural-numbers-network.jpg');
        controller.screen.preloadImage('/assets/img/tour/neural-numbers-mnist.jpg');
      },
      onExit: () => {},
      sequences: [
        {
          id: 'neural-numbers-try',
          start: 9916 / 30,
          end: 9938 / 30,
          onEnter: (controller) => {
            controller.guide.showPrompt('Hier klicken, um weiterzumachen.');
          },
          onExit: (controller) => {
            controller.guide.hidePrompt();
          },
        },
        {
          id: 'neural-numbers-with-normalizer',
          start: 11644 / 30,
          end: 16815 / 30,
          onEnter: (controller) => {
            controller.screen.sendMessageToPage({ type: 'showNormalizer' });
          },
          onExit: (controller) => {
            controller.screen.sendMessageToPage({ type: 'hideNormalizer' });
          },
          sequences: [
            {
              id: 'neural-numbers-normalize',
              start: 12881 / 30,
              end: 12905 / 30,
              onEnter: (controller) => {
                controller.guide.showPrompt('Hier klicken, um weiterzumachen.');
              },
              onExit: (controller) => {
                controller.guide.hidePrompt();
              },
            },
            {
              id: 'neural-numbers-with-output',
              start: 12940 / 30,
              end: 16815 / 30,
              onEnter: (controller) => {
                controller.screen.sendMessageToPage({ type: 'showOutput' });
              },
              onExit: (controller) => {
                controller.screen.sendMessageToPage({ type: 'hideOutput' });
              },
              sequences: [
                {
                  id: 'neural-numbers-output',
                  start: 13869 / 30,
                  end: 13892 / 30,
                  onEnter: (controller) => {
                    controller.guide.showPrompt('Hier klicken, um weiterzumachen.');
                  },
                  onExit: (controller) => {
                    controller.guide.hidePrompt();
                  },
                },
                {
                  id: 'neural-numbers-network',
                  start: 13998 / 30,
                  end: 14846 / 30,
                  onEnter: (controller) => {
                    controller.screen.showImage('/assets/img/tour/neural-numbers-network.jpg');
                  },
                  onExit: (controller) => {
                    controller.screen.hideImage();
                  },
                },
                {
                  id: 'neural-numbers-mnist',
                  start: 14846 / 30,
                  end: 16381 / 30,
                  onEnter: (controller) => {
                    controller.screen.showImage('/assets/img/tour/neural-numbers-mnist.jpg');
                  },
                  onExit: (controller) => {
                    controller.screen.hideImage();
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'gradient-descent',
      title: '3 - Gradient Descent',
      start: 16837 / 30,
      end: 26381 / 30,
      onEnter: (controller) => {
        controller.guide.showLoader();
        controller.screen.showPage('/apps/gradient-descent-vg/index.html?lang=de').then(() => {
          controller.guide.hideLoader();
        });
        controller.screen.preloadImage('/assets/img/tour/gradient-descent-global.png');
        controller.screen.preloadImage('/assets/img/tour/gradient-descent-local.png');
        controller.screen.preloadImage('/assets/img/tour/gradient-descent-rocky.png');
      },
      onExit: () => {},
      sequences: [
        {
          id: 'gradient-descent-play',
          start: 18418 / 30,
          end: 18443 / 30,
          onEnter: (controller) => {
            controller.guide.showPrompt('Hier klicken, um weiterzumachen.');
          },
          onExit: (controller) => {
            controller.guide.hidePrompt();
          },
        },
        {
          id: 'gradient-descent-bottom',
          start: 21240 / 30,
          end: 24071 / 30,
          onEnter: () => {},
          onExit: () => {},
          sequences: [
            {
              id: 'gradient-descent-global',
              start: 21240 / 30,
              end: 21602 / 30,
              onEnter: (controller) => {
                controller.screen.showImage('/assets/img/tour/gradient-descent-global.png');
              },
              onExit: (controller) => {
                controller.screen.hideImage();
              },
            },
            {
              id: 'gradient-descent-local',
              start: 21602 / 30,
              end: 23617 / 30,
              onEnter: (controller) => {
                controller.screen.showImage('/assets/img/tour/gradient-descent-local.png');
              },
              onExit: (controller) => {
                controller.screen.hideImage();
              },
            },
            {
              id: 'gradient-descent-rocky',
              start: 23617 / 30,
              end: 24071 / 30,
              onEnter: (controller) => {
                controller.screen.showImage('/assets/img/tour/gradient-descent-rocky.png');
              },
              onExit: (controller) => {
                controller.screen.hideImage();
              },
            },
          ],
        },
      ],
    },
    {
      id: 'closing',
      title: 'Zusammenfassung',
      start: 26391 / 30,
      end: 29158 / 30,
      onEnter: (controller) => {
        controller.screen.clear();
      },
      onExit: () => {},
      sequences: [],
    },
  ],
};
